<template>
    <div class="x-field">
        <div class="x-checkbox">
            <el-tooltip :disabled="!tooltipContent"
                        effect="dark"
                        :content="tooltipContent"
                        :placement="tooltipPosition">
                <el-checkbox :value="value"
                             :disabled="disabled"
                             :border="border"
                             @input="handleInput($event)">
                    <template v-if="label">{{ label }}</template>
                    <i v-if="icon" :class="icon"></i>
                </el-checkbox>
            </el-tooltip>
        </div>
    </div>
</template>

<script>
export default {
    name: 'XCheckbox',
    props: {
        value: {
            default: ''
        },
        label: {
            type: String,
            default: null,
        },
        icon: {
            type: String,
            default: null,
        },
        border: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        tooltipContent: {
            type: String,
            default: null
        },
        tooltipPosition: {
            type: String,
            default: 'bottom'
        },
    },
    data() {
        return {}
    },
    methods: {
        handleInput(value) {
            this.$emit('input', value)
        },
    }
}
</script>
